const cards = [
  {
    title: '《长安十二时辰》',
    desc: '古装悬疑巨制，唐朝反恐24小时，雷佳音易烊千玺主演',
    tag: '国产剧 · 9.2分',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20city%20scene%2C%20traditional%20architecture%20with%20red%20lanterns%2C%20dramatic%20moody%20lighting%2C%20historical%20drama%20poster%20style%2C%20warm%20golden%20and%20crimson%20tones%2C%20epic%20cinematic%20composition&width=600&height=400&seq=card-01-2026&orientation=landscape',
    alt: '长安十二时辰',
  },
  {
    title: '《首尔告白》',
    desc: '治愈系韩剧，跨越国界的浪漫爱情，年度最甜都市剧',
    tag: '韩剧 · 8.8分',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20Seoul%20cityscape%20at%20sunset%2C%20cherry%20blossom%20trees%2C%20couple%20walking%20hand%20in%20hand%2C%20warm%20pink%20and%20golden%20lighting%2C%20Korean%20drama%20poster%20aesthetic%2C%20dreamy%20soft%20focus&width=600&height=400&seq=card-02-2026&orientation=landscape',
    alt: '首尔告白',
  },
  {
    title: '《深海密码》',
    desc: '年度悬疑大作，深海科考队被困神秘海底基地',
    tag: '国产剧 · 8.9分',
    imageUrl: 'https://readdy.ai/api/search-image?query=Deep%20sea%20research%20facility%2C%20mysterious%20blue%20underwater%20lighting%2C%20futuristic%20interior%2C%20suspenseful%20atmosphere%2C%20sci-fi%20thriller%20aesthetic%2C%20dramatic%20shadows%2C%20cinematic%20wide%20shot&width=600&height=400&seq=card-03-2026&orientation=landscape',
    alt: '深海密码',
  },
  {
    title: '《山河故人》',
    desc: '三代人家国史诗，年代大剧，豆瓣9.2分口碑神作',
    tag: '国产剧 · 9.2分',
    imageUrl: 'https://readdy.ai/api/search-image?query=Nostalgic%201980s%20Chinese%20courtyard%20house%2C%20family%20gathering%2C%20warm%20sunset%20golden%20lighting%2C%20vintage%20aesthetic%2C%20emotional%20family%20drama%20mood%2C%20traditional%20Chinese%20setting&width=600&height=400&seq=card-04-2026&orientation=landscape',
    alt: '山河故人',
  },
  {
    title: '《职场风云录》',
    desc: '真实还原互联网大厂职场生态，打工人必看励志剧',
    tag: '国产剧 · 8.5分',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20office%20interior%20with%20open%20workspace%2C%20young%20professionals%20working%2C%20glass%20walls%2C%20city%20skyline%20through%20windows%2C%20warm%20modern%20lighting%2C%20corporate%20drama%20aesthetic%2C%20clean%20composition&width=600&height=400&seq=card-05-2026&orientation=landscape',
    alt: '职场风云录',
  },
  {
    title: '《月光变奏曲》',
    desc: '奇幻爱情韩剧，月光下交换灵魂的奇妙故事',
    tag: '韩剧 · 8.7分',
    imageUrl: 'https://readdy.ai/api/search-image?query=Magical%20moonlit%20night%20scene%2C%20full%20moon%20over%20traditional%20Korean%20rooftops%2C%20soft%20silver%20and%20blue%20moonlight%2C%20romantic%20fantasy%20atmosphere%2C%20dreamy%20Korean%20drama%20aesthetic%2C%20ethereal%20mood&width=600&height=400&seq=card-06-2026&orientation=landscape',
    alt: '月光变奏曲',
  },
  {
    title: '《边境追凶》',
    desc: '硬核刑侦剧，边防警察跨国追捕，全程高能无尿点',
    tag: '国产剧 · 8.6分',
    imageUrl: 'https://readdy.ai/api/search-image?query=Rugged%20border%20landscape%20at%20dusk%2C%20police%20vehicles%2C%20dramatic%20sky%2C%20crime%20thriller%20aesthetic%2C%20mountainous%20terrain%2C%20tense%20atmosphere%2C%20warm%20and%20cool%20contrasting%20lighting%2C%20cinematic%20action&width=600&height=400&seq=card-07-2026&orientation=landscape',
    alt: '边境追凶',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            热门剧集推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            精选当前最受欢迎的电视剧，口碑与热度兼备
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-5">
          {cards.map((card) => (
            <div
              key={card.title}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={card.imageUrl}
                  alt={card.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    (target.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-2.5 left-2.5">
                  <span className="px-2 py-0.5 text-[11px] font-medium rounded-full bg-primary-500 text-white whitespace-nowrap">
                    {card.tag.split('·')[0].trim()}
                  </span>
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 opacity-0 group-hover:opacity-100 transition-opacity text-primary-500">
                    <i className="ri-play-fill text-2xl"></i>
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-2">
                  {card.desc}
                </p>
                <span className="text-[11px] text-accent-600 font-medium">{card.tag}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}